<template>
    <div>
      <div class="invalid-feedback" v-if="hasError">
          {{ message }}
      </div>
    </div>
  </template>
  
  <script>
  import { ErreurConfig } from '@/core/plugins/errors';

  export default {
    name: 'MessageError',
    props:['code','hasError'],
    computed:{
      message(){
        const msgFind = this.erreurs.find(x => x.code === this.code)
        return msgFind.text
      }
    },
    data(){
        return {
            erreurs: ErreurConfig
        }
    }
  }
  </script>
  
  <style>
  .invalid-feedback {
    display: block !important;
  }
  </style>
  